module.exports = __webpack_public_path__ + "img/test-drive-highway.1bf1fec3.svg";